import * as Yup from 'yup';

export const AddOnsFormSchema = Yup.object().shape({
  addOns: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Add-on name is required'),
      price: Yup.number()
        .typeError('Price must be a number')
        .positive('Price must be positive')
        .required('Price is required'),
      // planId: Yup.string(), // Optional: Add if needed for backend
      features: Yup.array()
        .of(
          Yup.object().shape({
            point: Yup.string().required('Feature description is required'),
          })
        )
        .min(1, 'At least one feature bullet point is required')
        .required('Features are required'),
    })
  ),
});
